import React from 'react';
import { Oval } from 'react-loader-spinner';
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Colors } from 'modules/theme';
import { Button } from '../Button';
import { CloseButton } from '../CloseButton';
import styles from './Dialog.module.scss';

function Dialog({
  onClose,
  title,
  onAction,
  onSecondaryAction,
  secondaryActionBtnLabel,
  onCancel,
  actionBtnLabel,
  actionDisabled,
  children,
  loading,
  inProgress,
  cancelBtnLabel = 'Cancel',
  containerStyle,
  subtitleStyle,
  subtitleText,
  renderFooterInfo,
  error,
  errorMessage,
  footerStyle,
}) {
  function handleCancel() {
    if (onCancel) {
      onCancel();
    }

    if (onSecondaryAction) {
      onSecondaryAction();
    }

    if (onClose) {
      onClose();
    }
  }

  return (
    <MuiDialog
      open
      onClose={handleCancel}
      disableEscapeKeyDown
      slotProps={{
        paper: {
          className: styles.container,
          style: containerStyle,
        },
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          },
        },
      }}
    >
      {loading && (
        <div className={styles.loaderContainer}>
          <Oval
            secondaryColor={Colors.darkBlue}
            color={Colors.darkBlue}
            width={30}
            height={30}
          />
        </div>
      )}
      <DialogTitle
        className={styles.header}
        sx={{
          padding: 0,
        }}
      >
        <div className={styles.title}>
          <h2 style={{ marginBottom: 0 }}>{title}</h2>
          <div className={styles.closeButtonContainer}>
            <CloseButton onClick={handleCancel} />
          </div>
        </div>
      </DialogTitle>
      {error && <p className={styles.error}>{errorMessage}</p>}
      {subtitleText && (
        <div className={styles.subtitle} style={subtitleStyle}>
          {subtitleText}
        </div>
      )}
      <DialogContent className={styles.children} sx={{ padding: 0 }}>
        {children}
      </DialogContent>
      <DialogActions className={styles.footer} style={footerStyle}>
        {onCancel && (
          <Button
            secondary
            className={styles.button}
            onClick={onSecondaryAction || handleCancel}
          >
            {secondaryActionBtnLabel || cancelBtnLabel}
          </Button>
        )}
        {onAction && (
          <Button
            disabled={actionDisabled}
            className={styles.button}
            onClick={onAction}
            primary
            id="submit-button"
            type="submit"
            loading={inProgress}
          >
            {actionBtnLabel}
          </Button>
        )}
      </DialogActions>
      {renderFooterInfo && renderFooterInfo()}
    </MuiDialog>
  );
}

export default Dialog;
